/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Dividend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AnalysisResponse
 */
export interface AnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof AnalysisResponse
     */
    'paymentDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'netDividend'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'dividendYieldAvg'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'dividendCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'yearlyPayoutRatio'?: number;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'period'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'totalYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'totalYieldPrevYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'totalDividend'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'dividendPayoutRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'dividendPayoutRatioPrevYear'?: number;
}
/**
 * 
 * @export
 * @interface Data2
 */
export interface Data2 {
    /**
     * 
     * @type {string}
     * @memberof Data2
     */
    'period'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Data2
     */
    'dividendYieldRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data2
     */
    'dividendAmount'?: number;
}
/**
 * 
 * @export
 * @interface DeclaredResponseCustom
 */
export interface DeclaredResponseCustom {
    /**
     * 
     * @type {string}
     * @memberof DeclaredResponseCustom
     */
    'paymentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeclaredResponseCustom
     */
    'equity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeclaredResponseCustom
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'netDividendPerShare'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'dividendYieldTTM'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'threeYearAverageDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'threeYearDividendCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'threeYearRatioCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'threeYearAvaregeProfitDistributeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'pddd'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'fk'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'ybgYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeclaredResponseCustom
     */
    'yearlyYield'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeclaredResponseCustom
     */
    'numberOfInstallments'?: string | null;
}
/**
 * 
 * @export
 * @interface DividendFilteringResponseCustom
 */
export interface DividendFilteringResponseCustom {
    /**
     * 
     * @type {string}
     * @memberof DividendFilteringResponseCustom
     */
    'equity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DividendFilteringResponseCustom
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'lastYearDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'threeYearAverageDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'fiveYearAverageDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'ybgYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'yearlyYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'fk'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'pddd'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'threeYearDividendCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'threeYearRatioCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof DividendFilteringResponseCustom
     */
    'threeYearAvaregeProfitDistributeRatio'?: number;
}
/**
 * 
 * @export
 * @interface ExpectedDividendResponseCustom
 */
export interface ExpectedDividendResponseCustom {
    /**
     * 
     * @type {string}
     * @memberof ExpectedDividendResponseCustom
     */
    'equity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpectedDividendResponseCustom
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'expectedDividend'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'dividendYieldTTM'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'twoYearAverageDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'threeYearAverageDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'pddd'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'fk'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'ybgYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpectedDividendResponseCustom
     */
    'yearlyYield'?: number;
}
/**
 * 
 * @export
 * @interface GraphData2Response
 */
export interface GraphData2Response {
    /**
     * 
     * @type {SeriNames2}
     * @memberof GraphData2Response
     */
    'seriNames'?: SeriNames2;
    /**
     * 
     * @type {Array<Data2>}
     * @memberof GraphData2Response
     */
    'data'?: Array<Data2> | null;
}
/**
 * 
 * @export
 * @interface GraphDataReponse
 */
export interface GraphDataReponse {
    /**
     * 
     * @type {SerieNames}
     * @memberof GraphDataReponse
     */
    'seriNames'?: SerieNames;
    /**
     * 
     * @type {Array<Data>}
     * @memberof GraphDataReponse
     */
    'data'?: Array<Data> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IndexList = {
    Xgmyo: 'XGMYO',
    Xtast: 'XTAST',
    Xu030: 'XU030',
    Xu100: 'XU100',
    Xutum: 'XUTUM',
    Xtmtu: 'XTMTU'
} as const;

export type IndexList = typeof IndexList[keyof typeof IndexList];


/**
 * 
 * @export
 * @enum {string}
 */

export const IndexLiteList = {
    Xu030: 'XU030',
    Xutum: 'XUTUM'
} as const;

export type IndexLiteList = typeof IndexLiteList[keyof typeof IndexLiteList];


/**
 * 
 * @export
 * @interface IndifiniteDateResponseCustom
 */
export interface IndifiniteDateResponseCustom {
    /**
     * 
     * @type {string}
     * @memberof IndifiniteDateResponseCustom
     */
    'equity'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'netDividendPerShare'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'dividendYieldTTM'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'threeYearAverageDividendYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'threeYearDividendCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'threeYearRatioCAGR'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'threeYearAvaregeProfitDistributeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'pddd'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'fk'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'ybgYield'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndifiniteDateResponseCustom
     */
    'yearlyYield'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndifiniteDateResponseCustom
     */
    'installement'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Month = {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    All: 'All'
} as const;

export type Month = typeof Month[keyof typeof Month];


/**
 * 
 * @export
 * @interface PastDividendValueClone
 */
export interface PastDividendValueClone {
    /**
     * 
     * @type {string}
     * @memberof PastDividendValueClone
     */
    'paymentDateTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PastDividendValueClone
     */
    'netDividend'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PastDividendValueClone
     */
    'dividendYieldAvg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PastDividendValueClone
     */
    'dividendCAGR'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PastDividendValueClone
     */
    'yearlyPayoutRatio'?: number | null;
}
/**
 * 
 * @export
 * @interface PastDividendsResponseCustom
 */
export interface PastDividendsResponseCustom {
    /**
     * 
     * @type {string}
     * @memberof PastDividendsResponseCustom
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PastDividendsResponseCustom
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {Array<PastDividendValueClone>}
     * @memberof PastDividendsResponseCustom
     */
    'dividends'?: Array<PastDividendValueClone> | null;
}
/**
 * 
 * @export
 * @interface SeriNames2
 */
export interface SeriNames2 {
    /**
     * 
     * @type {string}
     * @memberof SeriNames2
     */
    'period'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SeriNames2
     */
    'dividendYieldRatio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SeriNames2
     */
    'dividendAmount'?: string | null;
}
/**
 * 
 * @export
 * @interface SerieNames
 */
export interface SerieNames {
    /**
     * 
     * @type {string}
     * @memberof SerieNames
     */
    'totalYield'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SerieNames
     */
    'totalYieldPrevYear'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SerieNames
     */
    'period'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SerieNames
     */
    'totalDividend'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SerieNames
     */
    'dividendPayoutRatio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SerieNames
     */
    'dividendPayoutRatioPrevYear'?: string | null;
}

/**
 * DividendApi - axios parameter creator
 * @export
 */
export const DividendApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendAnalysisGet: async (code: string, identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiDividendAnalysisGet', 'code', code)
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendAnalysisGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['Code'] = code;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDataforgraph2Get: async (identityToken: string, code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendDataforgraph2Get', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/dataforgraph2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['Code'] = code;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDataforgraphGet: async (identityToken: string, code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendDataforgraphGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/dataforgraph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['Code'] = code;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {Month} [month] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDeclaredGet: async (identityToken: string, month?: Month, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendDeclaredGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/declared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['Month'] = month;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {IndexList} [indexCode] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDividendfilteringGet: async (identityToken: string, indexCode?: IndexList, securityCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendDividendfilteringGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/dividendfiltering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (indexCode !== undefined) {
                localVarQueryParameter['IndexCode'] = indexCode;
            }

            if (securityCode !== undefined) {
                localVarQueryParameter['SecurityCode'] = securityCode;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {IndexLiteList} [indexCode] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendExpecteddividendGet: async (identityToken: string, indexCode?: IndexLiteList, securityCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendExpecteddividendGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/expecteddividend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (indexCode !== undefined) {
                localVarQueryParameter['IndexCode'] = indexCode;
            }

            if (securityCode !== undefined) {
                localVarQueryParameter['SecurityCode'] = securityCode;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendIndefinitedateGet: async (identityToken: string, securityCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendIndefinitedateGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/indefinitedate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (securityCode !== undefined) {
                localVarQueryParameter['SecurityCode'] = securityCode;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendPastdividendGet: async (identityToken: string, securityCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiDividendPastdividendGet', 'identityToken', identityToken)
            const localVarPath = `/api/dividend/pastdividend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (securityCode !== undefined) {
                localVarQueryParameter['SecurityCode'] = securityCode;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DividendApi - functional programming interface
 * @export
 */
export const DividendApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DividendApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} code 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendAnalysisGet(code: string, identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalysisResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendAnalysisGet(code, identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendDataforgraph2Get(identityToken: string, code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphData2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendDataforgraph2Get(identityToken, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendDataforgraphGet(identityToken: string, code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphDataReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendDataforgraphGet(identityToken, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {Month} [month] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendDeclaredGet(identityToken: string, month?: Month, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeclaredResponseCustom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendDeclaredGet(identityToken, month, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {IndexList} [indexCode] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendDividendfilteringGet(identityToken: string, indexCode?: IndexList, securityCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DividendFilteringResponseCustom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendDividendfilteringGet(identityToken, indexCode, securityCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {IndexLiteList} [indexCode] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendExpecteddividendGet(identityToken: string, indexCode?: IndexLiteList, securityCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExpectedDividendResponseCustom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendExpecteddividendGet(identityToken, indexCode, securityCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendIndefinitedateGet(identityToken: string, securityCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IndifiniteDateResponseCustom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendIndefinitedateGet(identityToken, securityCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDividendPastdividendGet(identityToken: string, securityCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PastDividendsResponseCustom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDividendPastdividendGet(identityToken, securityCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DividendApi - factory interface
 * @export
 */
export const DividendApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DividendApiFp(configuration)
    return {
        /**
         * 
         * @param {string} code 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendAnalysisGet(code: string, identityToken: string, options?: any): AxiosPromise<Array<AnalysisResponse>> {
            return localVarFp.apiDividendAnalysisGet(code, identityToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDataforgraph2Get(identityToken: string, code?: string, options?: any): AxiosPromise<GraphData2Response> {
            return localVarFp.apiDividendDataforgraph2Get(identityToken, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDataforgraphGet(identityToken: string, code?: string, options?: any): AxiosPromise<GraphDataReponse> {
            return localVarFp.apiDividendDataforgraphGet(identityToken, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {Month} [month] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDeclaredGet(identityToken: string, month?: Month, options?: any): AxiosPromise<Array<DeclaredResponseCustom>> {
            return localVarFp.apiDividendDeclaredGet(identityToken, month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {IndexList} [indexCode] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendDividendfilteringGet(identityToken: string, indexCode?: IndexList, securityCode?: string, options?: any): AxiosPromise<Array<DividendFilteringResponseCustom>> {
            return localVarFp.apiDividendDividendfilteringGet(identityToken, indexCode, securityCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {IndexLiteList} [indexCode] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendExpecteddividendGet(identityToken: string, indexCode?: IndexLiteList, securityCode?: string, options?: any): AxiosPromise<Array<ExpectedDividendResponseCustom>> {
            return localVarFp.apiDividendExpecteddividendGet(identityToken, indexCode, securityCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendIndefinitedateGet(identityToken: string, securityCode?: string, options?: any): AxiosPromise<Array<IndifiniteDateResponseCustom>> {
            return localVarFp.apiDividendIndefinitedateGet(identityToken, securityCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDividendPastdividendGet(identityToken: string, securityCode?: string, options?: any): AxiosPromise<Array<PastDividendsResponseCustom>> {
            return localVarFp.apiDividendPastdividendGet(identityToken, securityCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DividendApi - object-oriented interface
 * @export
 * @class DividendApi
 * @extends {BaseAPI}
 */
export class DividendApi extends BaseAPI {
    /**
     * 
     * @param {string} code 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendAnalysisGet(code: string, identityToken: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendAnalysisGet(code, identityToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendDataforgraph2Get(identityToken: string, code?: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendDataforgraph2Get(identityToken, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendDataforgraphGet(identityToken: string, code?: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendDataforgraphGet(identityToken, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {Month} [month] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendDeclaredGet(identityToken: string, month?: Month, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendDeclaredGet(identityToken, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {IndexList} [indexCode] 
     * @param {string} [securityCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendDividendfilteringGet(identityToken: string, indexCode?: IndexList, securityCode?: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendDividendfilteringGet(identityToken, indexCode, securityCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {IndexLiteList} [indexCode] 
     * @param {string} [securityCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendExpecteddividendGet(identityToken: string, indexCode?: IndexLiteList, securityCode?: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendExpecteddividendGet(identityToken, indexCode, securityCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [securityCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendIndefinitedateGet(identityToken: string, securityCode?: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendIndefinitedateGet(identityToken, securityCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [securityCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DividendApi
     */
    public apiDividendPastdividendGet(identityToken: string, securityCode?: string, options?: AxiosRequestConfig) {
        return DividendApiFp(this.configuration).apiDividendPastdividendGet(identityToken, securityCode, options).then((request) => request(this.axios, this.basePath));
    }
}



